import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_OPERATORS_RESET = 'DELETE_OPERATORS_RESET';
export const DELETE_OPERATORS_LOADING = 'DELETE_OPERATORS_LOADING';
export const DELETE_OPERATORS_SUCCESS = 'DELETE_OPERATORS_SUCCESS';
export const DELETE_OPERATORS_REJECT = 'DELETE_OPERATORS_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteOperatorsReset = () => ({ type: DELETE_OPERATORS_RESET });
export const deleteOperatorsLoading = () => ({ type: DELETE_OPERATORS_LOADING });
export const deleteOperatorsSuccess = (payload) => ({ type: DELETE_OPERATORS_SUCCESS, payload });
export const deleteOperatorsReject = (payload) => ({ type: DELETE_OPERATORS_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteOperatorsRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/api/Users/DeleteOperator/${data.id}`, options);
};